import React from 'react';
import { withRouter } from 'react-router-dom';
import { master } from '../../assets/main';

const Header = ({ points, match }) => {
  const { level, game } = match && match.params;
  let type;
  if (typeof level !== 'undefined') {
    const theArray = master.levelsObject[+level - 1][+game - 1];
    if (theArray) {
      type = theArray.type;
    }
  }

  return (
    <div id="header">
      <img
        src="https://media1.giphy.com/media/lqSDx8SI1916ysr4eq/giphy.gif?cid=ecf05e47bbc45ebd1d5262607cde98fd050cef1ec647705c&rid=giphy.gif"
        alt="header"
      />
      <h1>English Learning App</h1>
      {typeof level !== 'undefined' && <h3>{type}</h3>}
      <div id="header-wrapper">
        {points > 0 && (
          <div id="points-section">
            <span>{points}</span> {points < 2 ? 'Point' : 'Points'}
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(Header);
